(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    const progressSelector = '[data-nw-article-progress]';
    const initializedBars = new WeakMap();

    const getHeaderBottom = () => {
      const header = document.querySelector('[data-header]');
      const headerContainer = header?.closest('.shopify-section') || header;

      if (!headerContainer) return 0;

      const rect = headerContainer.getBoundingClientRect();
      return Math.max(0, Math.min(window.innerHeight, rect.bottom));
    };

    const initializeProgressBars = (root = document) => {
      root.querySelectorAll(progressSelector).forEach((progressBar) => {
        if (initializedBars.has(progressBar)) return;

        const sectionContainer = progressBar.closest('.shopify-section');
        const articleContent = sectionContainer?.querySelector('[data-nw-article-content]');

        if (!articleContent) return;

        const progressValue = progressBar.querySelector('.nw-article-progress__value');
        if (!progressValue) return;

        let frameId = null;
        let lastAriaValue = -1;

        const updateProgress = () => {
          frameId = null;

          const headerBottom = getHeaderBottom();
          const contentRect = articleContent.getBoundingClientRect();
          const scrollTop = window.scrollY;
          const readingStart = scrollTop + contentRect.top - headerBottom;
          const readingEnd = scrollTop + contentRect.bottom - window.innerHeight;
          const readingDistance = readingEnd - readingStart;
          let progress = 0;

          if (readingDistance <= 0) {
            progress = scrollTop >= readingStart ? 1 : 0;
          } else {
            progress = (scrollTop - readingStart) / readingDistance;
          }

          progress = Math.min(1, Math.max(0, progress));
          progressValue.style.transform = `scaleX(${progress})`;
          progressBar.style.setProperty('--nw-article-progress-top', `${Math.round(headerBottom)}px`);

          const ariaValue = Math.round(progress * 100);
          if (ariaValue !== lastAriaValue) {
            progressBar.setAttribute('aria-valuenow', ariaValue);
            lastAriaValue = ariaValue;
          }
        };

        const requestProgressUpdate = () => {
          if (frameId !== null) return;
          frameId = window.requestAnimationFrame(updateProgress);
        };

        window.addEventListener('scroll', requestProgressUpdate, { passive: true });
        window.addEventListener('resize', requestProgressUpdate);
        const resizeObserver = typeof ResizeObserver === 'function'
          ? new ResizeObserver(requestProgressUpdate)
          : null;
        resizeObserver?.observe(articleContent);

        initializedBars.set(progressBar, {
          update: requestProgressUpdate,
          destroy: () => {
            window.removeEventListener('scroll', requestProgressUpdate);
            window.removeEventListener('resize', requestProgressUpdate);
            resizeObserver?.disconnect();
            if (frameId !== null) window.cancelAnimationFrame(frameId);
          }
        });

        updateProgress();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeProgressBars(), { once: true });
    } else {
      initializeProgressBars();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeProgressBars(event.target);
      document.querySelectorAll(progressSelector).forEach((progressBar) => {
        initializedBars.get(progressBar)?.update();
      });
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(progressSelector).forEach((progressBar) => {
        initializedBars.get(progressBar)?.destroy();
        initializedBars.delete(progressBar);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const cartFocusStorageKey = 'nw-cart-focus';

  const getCartForm = (element) => element && element.closest('.nw-cart__form');

  const setCartStatus = (form, message) => {
    const status = form && form.querySelector('[data-nw-cart-status]');
    if (!status) return;
    status.textContent = message;
    status.hidden = !message;
  };

  const clearQuantityError = (form, input) => {
    if (input) {
      input.setCustomValidity('');
      input.removeAttribute('aria-invalid');
    }

    const error = form && form.querySelector('[data-nw-cart-error]');
    if (!error) return;
    error.textContent = '';
    error.hidden = true;
  };

  const showQuantityError = (form, input) => {
    const message = 'Enter a whole number of 0 or more.';
    input.setCustomValidity(message);
    input.setAttribute('aria-invalid', 'true');

    const error = form && form.querySelector('[data-nw-cart-error]');
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }

    setCartStatus(form, '');
    input.focus({ preventScroll: true });
  };

  const isValidQuantity = (input) => {
    input.setCustomValidity('');
    const rawValue = input.value.trim();
    const quantity = Number(rawValue);
    return rawValue !== '' && Number.isInteger(quantity) && quantity >= 0 && input.checkValidity();
  };

  const markQuantityPending = (input) => {
    const form = getCartForm(input);
    if (!form) return false;

    clearQuantityError(form, input);
    const isDirty = input.value.trim() !== input.dataset.nwInitialQuantity;
    input.dataset.nwDirty = isDirty ? 'true' : 'false';

    const hasPendingQuantity = Array.from(form.querySelectorAll('.nw-qty__input'))
      .some((quantityInput) => quantityInput.dataset.nwDirty === 'true');
    setCartStatus(form, hasPendingQuantity ? 'Quantity changed. Updating when you finish.' : '');
    return isDirty;
  };

  const rememberCartFocus = (form, input, target = 'quantity') => {
    try {
      const state = target === 'quantity' && input
        ? { target, lineKey: input.dataset.nwLineKey }
        : { target: 'update' };
      sessionStorage.setItem(cartFocusStorageKey, JSON.stringify(state));
      form.dataset.nwFocusStored = 'true';
    } catch (error) {
      // Focus restoration is a progressive enhancement.
    }
  };

  const submitCartQuantity = (input) => {
    const form = getCartForm(input);
    if (!form || form.dataset.nwSubmitting === 'true') return;
    if (!markQuantityPending(input)) return;

    if (!isValidQuantity(input)) {
      showQuantityError(form, input);
      return;
    }

    rememberCartFocus(form, input);
    const updateButton = form.querySelector('.nw-cart__update');
    if (!updateButton) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(updateButton);
    } else {
      updateButton.click();
    }
  };

  document.addEventListener('input', (event) => {
    if (!event.target.matches('.nw-qty__input')) return;
    markQuantityPending(event.target);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.nw-qty__input')) return;
    submitCartQuantity(event.target);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-nw-qty-step]');
    if (!button) return;

    const wrapper = button.closest('[data-nw-qty]');
    const input = wrapper && wrapper.querySelector('.nw-qty__input');
    if (!input) return;

    const step = Number(button.dataset.nwQtyStep) || 0;
    const next = Math.max(0, (Number(input.value) || 0) + step);
    if (next === Number(input.value)) return;

    input.value = next;
    markQuantityPending(input);
    submitCartQuantity(input);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.nw-cart__form');
    if (!form) return;

    const invalidInput = Array.from(form.querySelectorAll('.nw-qty__input'))
      .find((input) => !isValidQuantity(input));
    if (invalidInput) {
      event.preventDefault();
      showQuantityError(form, invalidInput);
      return;
    }

    if (event.submitter && event.submitter.name === 'checkout') return;

    if (form.dataset.nwSubmitting === 'true') {
      event.preventDefault();
      return;
    }

    form.dataset.nwSubmitting = 'true';
    form.setAttribute('aria-busy', 'true');
    setCartStatus(form, 'Updating cart…');

    if (!form.dataset.nwFocusStored) {
      const activeInput = document.activeElement && document.activeElement.matches('.nw-qty__input')
        ? document.activeElement
        : null;
      rememberCartFocus(form, activeInput, activeInput ? 'quantity' : 'update');
    }

    queueMicrotask(() => {
      form.querySelectorAll('[data-nw-qty-step], .nw-cart__update').forEach((control) => {
        control.disabled = true;
      });
    });
  });

  try {
    const focusState = JSON.parse(sessionStorage.getItem(cartFocusStorageKey));
    sessionStorage.removeItem(cartFocusStorageKey);

    if (focusState) {
      const form = document.querySelector('.nw-cart__form');
      const updateButton = form && form.querySelector('.nw-cart__update');
      const quantityInput = focusState.target === 'quantity'
        ? Array.from(form ? form.querySelectorAll('.nw-qty__input') : [])
          .find((input) => input.dataset.nwLineKey === focusState.lineKey)
        : null;
      const target = quantityInput || updateButton;

      if (target) {
        requestAnimationFrame(() => target.focus({ preventScroll: true }));
      }
    }
  } catch (error) {
    try {
      sessionStorage.removeItem(cartFocusStorageKey);
    } catch (storageError) {
      // Focus restoration is a progressive enhancement.
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* v46: variant selection driven by option values, so a product can carry
     several options (Style + Colour) instead of one flat swatch row. */
  (() => {
    const initPicker = (scope) => {
      const picker = scope.querySelector('[data-nw-variant-picker]');
      if (!picker || picker.dataset.nwReady === 'true') return;
      picker.dataset.nwReady = 'true';

      let variants = [];
      try {
        variants = JSON.parse(picker.querySelector('[data-nw-variant-data]').textContent);
      } catch (error) {
        return;
      }

      const form = scope.querySelector('#NurtureWiseProductForm');
      const idInput = form && form.querySelector("input[name='id']");
      const priceEl = scope.querySelector('[data-product-price]');
      const compareEl = scope.querySelector('[data-compare-price]');
      const addButton = scope.querySelector('[data-add-to-cart]');
      const paymentButton = scope.querySelector('.shopify-payment-button');
      const galleryImage = scope.querySelector('[data-product-image]');

      const chosenValues = () =>
        Array.from(picker.querySelectorAll('.nw-variant-value.is-selected'))
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((el) => el.dataset.optionValue);

      const apply = () => {
        const chosen = chosenValues();
        const variant = variants.find(
          (v) => v.options.length === chosen.length && v.options.every((o, i) => o === chosen[i])
        );

        if (priceEl && variant) priceEl.textContent = variant.price;

        if (compareEl) {
          const hasCompare = !!(variant && variant.compare);
          compareEl.textContent = hasCompare ? variant.compare : '';
          compareEl.hidden = !hasCompare;
        }

        const available = !!(variant && variant.available);

        if (addButton) {
          addButton.disabled = !available;
          addButton.dataset.available = available ? 'true' : 'false';
          addButton.textContent = available
            ? addButton.dataset.addLabel || 'Add to cart'
            : addButton.dataset.soldOutLabel || 'Sold out';
        }

        if (paymentButton) paymentButton.hidden = !available;

        if (galleryImage && variant && variant.image) {
          galleryImage.removeAttribute('srcset');
          galleryImage.removeAttribute('sizes');
          galleryImage.src = variant.image;
        }

        if (idInput && variant) {
          idInput.value = variant.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      picker.addEventListener('click', (event) => {
        const button = event.target.closest('[data-option-position]');
        if (!button) return;

        const position = button.dataset.optionPosition;
        picker.querySelectorAll('[data-option-position="' + position + '"]').forEach((el) => {
          const on = el === button;
          el.classList.toggle('is-selected', on);
          el.setAttribute('aria-checked', on ? 'true' : 'false');
        });

        const label = picker.querySelector('[data-selected-label="' + position + '"]');
        if (label) label.textContent = button.dataset.optionValue;

        apply();
      });
    };

    const boot = (root) => {
      (root || document).querySelectorAll('.nw-main-product').forEach(initPicker);
    };

    boot();
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  /* v46: keep the standalone Buy Now form in sync with the main product form. */
  (() => {
    const sync = () => {
      const source = document.querySelector('#NurtureWiseProductForm');
      const target = document.querySelector('[data-nw-buy-now]');
      if (!source || !target) return;

      const variant = source.querySelector("input[name='id']");
      const quantity = source.querySelector("input[name='quantity']");
      const buyVariant = target.querySelector('[data-buy-now-id]');
      const buyQuantity = target.querySelector('[data-buy-now-quantity]');

      if (variant && buyVariant) buyVariant.value = variant.value;
      if (quantity && buyQuantity) buyQuantity.value = Math.max(1, Number(quantity.value) || 1);
    };

    document.addEventListener('change', (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('#NurtureWiseProductForm')) sync();
    });

    sync();
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nw-banner-carousel')) {
    class NwBannerCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.slides = Array.from(this.querySelectorAll('[data-banner-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-banner-dot]'));
        this.previousButton = this.querySelector('[data-banner-previous]');
        this.nextButton = this.querySelector('[data-banner-next]');
        this.status = this.querySelector('[data-banner-status]');
        this.activeIndex = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.autoplay = this.dataset.autoplay === 'true';
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.isPaused = false;
        this.isVisible = !('IntersectionObserver' in window);
        this.pointerStartX = null;
        this.timer = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.handlePrevious = () => this.goTo(this.activeIndex - 1, true);
        this.handleNext = () => this.goTo(this.activeIndex + 1, true);
        this.handleKeydown = event => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.handlePrevious();
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.handleNext();
          }
        };
        this.handleVisibility = () => {
          if (document.hidden) {
            this.clearTimer();
          } else {
            this.schedule();
          }
        };
        this.handlePointerDown = event => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          this.pointerStartX = event.clientX;
        };
        this.handlePointerUp = event => {
          if (this.pointerStartX === null) return;
          const distance = event.clientX - this.pointerStartX;
          this.pointerStartX = null;
          if (Math.abs(distance) < 44) return;
          if (distance > 0) this.handlePrevious();
          else this.handleNext();
        };
        this.handleBlockSelect = event => {
          const slide = event.target.closest('[data-banner-slide]');
          if (!slide || !this.contains(slide)) return;
          this.isPaused = true;
          this.goTo(Number(slide.dataset.slideIndex), false);
        };

        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('pointerdown', this.handlePointerDown);
        this.addEventListener('pointerup', this.handlePointerUp);
        this.addEventListener('pointercancel', () => { this.pointerStartX = null; });
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('visibilitychange', this.handleVisibility);

        this.dots.forEach(dot => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slideIndex), true));
        });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => {
            this.isPaused = true;
            this.clearTimer();
          });
          this.addEventListener('mouseleave', () => {
            this.isPaused = false;
            this.schedule();
          });
          this.addEventListener('focusin', () => {
            this.isPaused = true;
            this.clearTimer();
          });
          this.addEventListener('focusout', event => {
            if (this.contains(event.relatedTarget)) return;
            this.isPaused = false;
            this.schedule();
          });
        }

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            this.isVisible = entries[0]?.isIntersecting ?? true;
            if (this.isVisible) {
              this.preloadSlide(this.activeIndex);
              this.preloadSlide(this.activeIndex + 1);
              this.schedule();
            } else {
              this.clearTimer();
            }
          }, { threshold: 0.18 });
          this.visibilityObserver.observe(this);
        }

        this.goTo(this.activeIndex, false);
      }

      disconnectedCallback() {
        this.clearTimer();
        this.visibilityObserver?.disconnect();
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('pointerdown', this.handlePointerDown);
        this.removeEventListener('pointerup', this.handlePointerUp);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      clearTimer() {
        window.clearTimeout(this.timer);
        this.timer = null;
      }

      preloadSlide(index) {
        if (!this.slides.length) return;

        const normalizedIndex = (index + this.slides.length) % this.slides.length;
        this.slides[normalizedIndex].querySelectorAll('img').forEach(image => {
          image.loading = 'eager';
          if (!image.complete) image.decode?.().catch(() => {});
        });
      }

      schedule() {
        this.clearTimer();
        if (!this.autoplay || this.reducedMotion || this.isPaused || !this.isVisible || document.hidden || this.slides.length < 2) return;

        const activeSlide = this.slides[this.activeIndex];
        const duration = Math.max(2000, Number(activeSlide?.dataset.duration) || 5000);
        this.timer = window.setTimeout(() => this.goTo(this.activeIndex + 1, false), duration);
      }

      goTo(index, userInitiated) {
        if (!this.slides.length) return;

        const normalizedIndex = (index + this.slides.length) % this.slides.length;
        this.activeIndex = normalizedIndex;

        if (this.isVisible) {
          this.preloadSlide(normalizedIndex);
          this.preloadSlide(normalizedIndex + 1);
        }

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === normalizedIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === normalizedIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });

        if (this.status && userInitiated) {
          this.status.textContent = `Slide ${normalizedIndex + 1} of ${this.slides.length}`;
        }

        this.schedule();
      }
    }

    customElements.define('nw-banner-carousel', NwBannerCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-honor-wall"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.nw-honor-wall--mobile-marquee';

    const setup = (section) => {
      if (!section || section.dataset.marqueeReady === 'true') return;
      section.dataset.marqueeReady = 'true';
      const viewport = section.querySelector('.nw-honor-wall__viewport');
      if (!viewport) return;

      const pause = () => section.classList.add('is-marquee-paused');
      const resume = () => section.classList.remove('is-marquee-paused');

      viewport.addEventListener('pointerdown', pause, { passive: true });
      viewport.addEventListener('pointerup', resume, { passive: true });
      viewport.addEventListener('pointercancel', resume, { passive: true });
    };

    const initialize = (root) => {
      if (root.matches && root.matches(selector)) setup(root);
      if (root.querySelectorAll) root.querySelectorAll(selector).forEach(setup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document));
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const section = event.target.closest(selector);
      if (section) section.classList.add('is-marquee-paused');
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const section = event.target.closest(selector);
      if (section) section.classList.remove('is-marquee-paused');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-membership"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const videoContainerSelector = '[data-nw-membership-video]';

    const getVideoContainers = (root = document) => {
      const containers = [];

      if (root instanceof Element && root.matches(videoContainerSelector)) {
        containers.push(root);
      }

      if (typeof root.querySelectorAll === 'function') {
        containers.push(...root.querySelectorAll(videoContainerSelector));
      }

      return containers;
    };

    const setPlaybackBlocked = (container, isBlocked) => {
      const section = container.closest('.nw-membership');
      const playButton = section?.querySelector('[data-nw-membership-video-play]');

      container.classList.toggle('is-playback-blocked', isBlocked);
      if (playButton) playButton.hidden = !isBlocked;
    };

    const attemptPlayback = (container, { userInitiated = false } = {}) => {
      const video = container.querySelector('video');

      if (!video || container.classList.contains('is-unavailable')) return;

      const hasReducedMotionOptIn = container.classList.contains('is-user-activated');

      if (reducedMotion.matches && !userInitiated && !hasReducedMotionOptIn) {
        video.pause();
        video.removeAttribute('autoplay');
        setPlaybackBlocked(container, true);
        return;
      }

      if (userInitiated) container.classList.add('is-user-activated');

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('autoplay', 'autoplay');

      const attemptId = String(Number(video.dataset.nwMembershipAttempt || 0) + 1);
      video.dataset.nwMembershipAttempt = attemptId;

      const playback = video.play();

      if (!playback || typeof playback.then !== 'function') {
        setPlaybackBlocked(container, video.paused);
        return;
      }

      playback
        .then(() => {
          if (video.dataset.nwMembershipAttempt !== attemptId) return;
          container.classList.remove('is-unavailable');
          setPlaybackBlocked(container, false);
        })
        .catch(() => {
          if (video.dataset.nwMembershipAttempt !== attemptId) return;
          setPlaybackBlocked(container, true);
        });
    };

    const syncMembershipVideos = (root = document) => {
      getVideoContainers(root).forEach((container) => {
        const video = container.querySelector('video');

        if (!video) return;

        video.tabIndex = -1;

        if (video.dataset.nwMembershipReady !== 'true') {
          video.dataset.nwMembershipReady = 'true';
          video.addEventListener('error', () => {
            container.classList.add('is-unavailable');
            setPlaybackBlocked(container, false);
          });

          const handleVideoReady = () => {
            container.classList.remove('is-unavailable');
            attemptPlayback(container);
          };

          video.addEventListener('loadeddata', handleVideoReady);
          video.addEventListener('canplay', handleVideoReady);
          video.addEventListener('playing', () => setPlaybackBlocked(container, false));

          const section = container.closest('.nw-membership');
          const playButton = section?.querySelector('[data-nw-membership-video-play]');
          playButton?.addEventListener('click', () => {
            attemptPlayback(container, { userInitiated: true });
          });
        }

        attemptPlayback(container);
      });
    };

    const retryBlockedVideos = () => {
      if (reducedMotion.matches) return;

      getVideoContainers().forEach((container) => {
        if (container.classList.contains('is-playback-blocked')) {
          attemptPlayback(container, { userInitiated: true });
        }
      });
    };

    const handleMotionChange = () => {
      if (reducedMotion.matches) {
        getVideoContainers().forEach((container) => container.classList.remove('is-user-activated'));
      }

      syncMembershipVideos();
    };

    syncMembershipVideos();

    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', handleMotionChange);
    } else {
      reducedMotion.addListener(handleMotionChange);
    }

    document.addEventListener('shopify:section:load', (event) => {
      syncMembershipVideos(event.target);
    });

    window.addEventListener('pageshow', () => syncMembershipVideos());
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') syncMembershipVideos();
    });
    document.addEventListener('pointerdown', retryBlockedVideos, { passive: true });
    document.addEventListener('keydown', retryBlockedVideos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-product-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nw-faq-tabs')) {
    class NwFaqTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.tabs = Array.from(this.querySelectorAll('[data-faq-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-faq-panel]'));
        if (!this.tabs.length) return;

        this.activeIndex = Math.max(0, this.tabs.findIndex(tab => tab.classList.contains('is-active')));

        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => this.activate(Number(tab.dataset.index), true));
        });

        this.handleKeydown = event => {
          const currentIndex = this.tabs.indexOf(document.activeElement);
          if (currentIndex === -1) return;

          let nextIndex = null;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = currentIndex + 1;
          else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = currentIndex - 1;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex === null) return;

          event.preventDefault();
          const normalized = (nextIndex + this.tabs.length) % this.tabs.length;
          this.activate(normalized, true);
          this.tabs[normalized].focus();
        };
        this.addEventListener('keydown', this.handleKeydown);

        this.handleShopifySelect = event => {
          const panel = event.target.closest('[data-faq-panel]');
          if (panel) {
            this.activate(Number(panel.dataset.index), false);
            return;
          }
          const tab = event.target.closest('[data-faq-tab]');
          if (tab) this.activate(Number(tab.dataset.index), false);
        };
        this.addEventListener('shopify:block:select', this.handleShopifySelect);

        this.activate(this.activeIndex, false);
      }

      disconnectedCallback() {
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('shopify:block:select', this.handleShopifySelect);
      }

      activate(index, userInitiated) {
        if (Number.isNaN(index)) return;

        this.activeIndex = index;

        this.tabs.forEach(tab => {
          const isActive = Number(tab.dataset.index) === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
          if (isActive && userInitiated && typeof tab.scrollIntoView === 'function') {
            tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        });

        this.panels.forEach(panel => {
          const isActive = Number(panel.dataset.index) === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }
    }

    customElements.define('nw-faq-tabs', NwFaqTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-product-sticky-purchase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (scope) => {
      const roots = scope.matches?.('[data-nw-sticky-purchase]')
        ? [scope]
        : Array.from(scope.querySelectorAll?.('[data-nw-sticky-purchase]') || []);

      roots.forEach((root) => {
        if (root.dataset.nwReady === 'true') return;

        const sourceProduct = document.querySelector('.nw-main-product');
        const sourceForm = sourceProduct?.querySelector('#NurtureWiseProductForm');
        const sourceVariant = sourceForm?.querySelector("input[name='id']");
        const sourceQuantity = sourceForm?.querySelector("input[name='quantity']");
        const sourceBuyNow = sourceProduct?.querySelector('[data-nw-buy-now]');
        const bar = root.querySelector('.nw-sticky-purchase__bar');
        const price = root.querySelector('[data-sticky-price]');
        const addForm = root.querySelector('.nw-sticky-purchase__form--add');
        const buyForm = root.querySelector('.nw-sticky-purchase__form--buy');
        const addButton = root.querySelector('[data-sticky-add]');
        const buyButton = root.querySelector('[data-sticky-buy]');
        const variantInputs = root.querySelectorAll('[data-sticky-variant-id]');
        const quantityInputs = root.querySelectorAll('[data-sticky-quantity]');

        if (!sourceForm || !bar || !addForm || !buyForm || !addButton || !buyButton || !variantInputs.length) return;

        let variants = [];
        try {
          variants = JSON.parse(root.querySelector('[data-sticky-variants]').textContent);
        } catch (error) {
          return;
        }

        root.dataset.nwReady = 'true';
        const controller = new AbortController();
        const { signal } = controller;
        let frame = 0;
        let editorForced = false;

        const selectedVariant = () => {
          const selectedId = sourceVariant?.value || variantInputs[0]?.value;
          return variants.find((variant) => String(variant.id) === String(selectedId));
        };

        const selectedQuantity = () => Math.max(1, Number(sourceQuantity?.value) || 1);

        const setVisible = (visible) => {
          root.classList.toggle('is-visible', visible);
          root.setAttribute('aria-hidden', visible ? 'false' : 'true');
          if ('inert' in root) root.inert = !visible;
        };

        const syncVariant = () => {
          const variant = selectedVariant();
          const available = Boolean(variant?.available);
          const quantity = selectedQuantity();

          variantInputs.forEach((input) => {
            input.value = variant?.id || '';
          });
          quantityInputs.forEach((input) => {
            input.value = quantity;
          });

          if (price) price.textContent = variant?.price || '';

          addButton.disabled = !available;
          addButton.textContent = available
            ? addButton.dataset.label || 'Add to cart'
            : addButton.dataset.soldOutLabel || 'Sold out';

          buyButton.disabled = !available;
          buyButton.textContent = buyButton.dataset.label || 'Buy it now';
        };

        const updateVisibility = () => {
          frame = 0;
          if (editorForced) {
            setVisible(true);
            return;
          }

          const controls = [sourceForm, sourceBuyNow].filter((element) => element && !element.hidden);
          const controlsBottom = Math.max(...controls.map((element) => element.getBoundingClientRect().bottom));
          setVisible(controls.length > 0 && controlsBottom <= 0);
        };

        const queueVisibility = () => {
          if (frame) return;
          frame = window.requestAnimationFrame(updateVisibility);
        };

        const lockForm = (form, button) => {
          form.addEventListener('submit', (event) => {
            if (form.dataset.submitting === 'true' || button.disabled) {
              event.preventDefault();
              return;
            }

            form.dataset.submitting = 'true';
            form.setAttribute('aria-busy', 'true');
            button.disabled = true;
            button.textContent = button.dataset.loadingLabel || button.dataset.label;
          }, { signal });
        };

        sourceForm.addEventListener('change', syncVariant, { signal });
        sourceForm.addEventListener('input', syncVariant, { signal });
        document.addEventListener('variant:change', syncVariant, { signal });
        window.addEventListener('scroll', queueVisibility, { passive: true, signal });
        window.addEventListener('resize', queueVisibility, { passive: true, signal });

        document.addEventListener('shopify:section:select', (event) => {
          if (!event.target.contains(root)) return;
          editorForced = true;
          setVisible(true);
        }, { signal });

        document.addEventListener('shopify:section:deselect', (event) => {
          if (!event.target.contains(root)) return;
          editorForced = false;
          queueVisibility();
        }, { signal });

        document.addEventListener('shopify:section:unload', (event) => {
          if (!event.target.contains(root)) return;
          controller.abort();
          if (frame) window.cancelAnimationFrame(frame);
        }, { signal });

        lockForm(addForm, addButton);
        lockForm(buyForm, buyButton);

        window.addEventListener('pageshow', () => {
          [addForm, buyForm].forEach((form) => {
            delete form.dataset.submitting;
            form.removeAttribute('aria-busy');
          });
          syncVariant();
        }, { signal });

        syncVariant();
        updateVisibility();
      });
    };

    setup(document);
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-user-manuals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nw-user-manuals')) {
    class NwUserManuals extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-manual-card]'));
        this.searchInput = this.querySelector('[data-manual-search]');
        this.filters = this.querySelector('[data-manual-filters]');
        this.emptyState = this.querySelector('[data-manual-empty]');
        this.activeCategory = 'all';
        this.abortController = new AbortController();

        this.buildFilters();

        if (this.searchInput) {
          this.searchInput.addEventListener('input', () => this.applyFilters(), {
            signal: this.abortController.signal,
          });
        }
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
      }

      buildFilters() {
        if (!this.filters) return;

        const categories = new Map();
        this.cards.forEach((card) => {
          const value = card.dataset.category || 'uncategorized';
          const label = card.dataset.categoryLabel || value;
          if (!categories.has(value)) categories.set(value, label);
        });

        this.filters.replaceChildren();
        this.filters.append(this.createFilterButton('all', this.dataset.allLabel || 'All products', true));
        categories.forEach((label, value) => {
          this.filters.append(this.createFilterButton(value, label, false));
        });
      }

      createFilterButton(value, label, pressed) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'nw-user-manuals__filter-button';
        button.dataset.categoryFilter = value;
        button.setAttribute('aria-pressed', String(pressed));
        button.textContent = label;
        button.addEventListener(
          'click',
          () => {
            this.activeCategory = value;
            this.querySelectorAll('[data-category-filter]').forEach((filterButton) => {
              filterButton.setAttribute('aria-pressed', String(filterButton === button));
            });
            this.applyFilters();
          },
          { signal: this.abortController.signal },
        );
        return button;
      }

      applyFilters() {
        const searchTerm = (this.searchInput?.value || '').trim().toLocaleLowerCase();
        let visibleCards = 0;

        this.cards.forEach((card) => {
          const matchesCategory = this.activeCategory === 'all' || card.dataset.category === this.activeCategory;
          const matchesSearch = !searchTerm || (card.dataset.searchText || '').includes(searchTerm);
          const shouldShow = matchesCategory && matchesSearch;
          card.hidden = !shouldShow;
          if (shouldShow) visibleCards += 1;
        });

        if (this.emptyState) this.emptyState.hidden = visibleCards !== 0;
      }
    }

    customElements.define('nw-user-manuals', NwUserManuals);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-video-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileViewport = window.matchMedia('(max-width: 749px)');

    const syncVideoTextMedia = (root = document) => {
      root.querySelectorAll('[data-nw-video-text-media]').forEach((media) => {
        const video = media.querySelector('video');
        if (!video) return;

        const shouldAutoplay = media.dataset.autoplay === 'true';
        const preferredPoster = mobileViewport.matches
          ? (media.dataset.mobilePoster || media.dataset.desktopPoster)
          : (media.dataset.desktopPoster || media.dataset.mobilePoster);

        if (preferredPoster && video.getAttribute('poster') !== preferredPoster) {
          video.setAttribute('poster', preferredPoster);
        }

        if (video.dataset.nwVideoTextReady !== 'true') {
          video.dataset.nwVideoTextReady = 'true';
          video.addEventListener('error', () => {
            media.classList.remove('is-ready');
            media.classList.add('is-unavailable');
          });
          video.addEventListener('canplay', () => {
            media.classList.remove('is-unavailable');
            media.classList.add('is-ready');
          });
          video.addEventListener('loadeddata', () => media.classList.add('is-ready'));
        }

        if (!shouldAutoplay) {
          if (video.readyState >= 2) media.classList.add('is-ready');
          return;
        }

        video.muted = true;
        video.loop = true;
        video.playsInline = true;

        if (reducedMotion.matches) {
          video.pause();
          video.removeAttribute('autoplay');
          media.classList.remove('is-ready');
          return;
        }

        video.setAttribute('autoplay', 'autoplay');
        const playback = video.play();
        if (playback) {
          playback.catch(() => {
            media.classList.remove('is-ready');
            media.classList.add('is-unavailable');
          });
        }
      });
    };

    syncVideoTextMedia();

    const handleMotionChange = () => syncVideoTextMedia();
    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', handleMotionChange);
      mobileViewport.addEventListener('change', handleMotionChange);
    } else {
      reducedMotion.addListener(handleMotionChange);
      mobileViewport.addListener(handleMotionChange);
    }

    document.addEventListener('shopify:section:load', (event) => {
      syncVideoTextMedia(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
